import React from 'react'
import TextField from 'material-ui/TextField'
import _ from 'lodash'

class ShippingData extends React.Component {

  render() {
    const {  item, handleChangeShipping, styles, disableFields } = this.props
    return (
      <div>
        <h2>Shipping Data</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          <TextField
            floatingLabelText="Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.shippingData.height}
            name="height"
            onChange={!disableFields ? handleChangeShipping : ''}
            style={styles.inputStyle}
            type = "number"
          />
          <TextField
            floatingLabelText="Width"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.shippingData.width}
            name="width"
            onChange={!disableFields ? handleChangeShipping : ''}
            style={styles.inputStyle}
            type = "number"
          />
          <TextField
            floatingLabelText="Length"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.shippingData.length}
            name="length"
            onChange={!disableFields ? handleChangeShipping : ''}
            style={styles.inputStyle}
            type = "number"
          />
          <TextField
            floatingLabelText="Weight"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.shippingData.weight}
            name="weight"
            onChange={!disableFields ? handleChangeShipping : ''}
            style={styles.inputStyle}
            type = "number"
          />
        
        </div>
      </div>
    )
  }
}
export default ShippingData


// WEBPACK FOOTER //
// ./src/components/items/Common/ShippingData.js